import { useEffect } from "react";
import Layout from '../utils/core/Layout';
import './CookiesPolicy.css'; 

const ContactPage = () => {
  useEffect(() => {
    // scroll only when the page URL contains #top
    if (window.location.hash === "#top") {
      const heading = document.querySelector(".policy-page");
      if (heading) {
        heading.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, []);

  return (
    <Layout>
      <div className="policy-page">
        <h1 className="policy-title">Contact Us</h1>

        {/* Blue banner */}
        <div className="policy-banner">
          <p className="policy-banner-text">
            WE WOULD LOVE TO HEAR FROM YOU
          </p>
        </div>

        <section className="policy-section">
          <h2>General Enquiries</h2>
          <p>
            For enquiries, contact the email: <a href="mailto:enquiries@goneet.com">enquiries@goneet.com</a>
          </p>
        </section>
      </div>
    </Layout>
  );
};

export default ContactPage;
